import {
  useAwardsStore,
  useDiningsStore,
  useFacilitiesStore,
  useHotelStore,
  useLabelsStore,
  useMeetingsStore,
  useNewsStore,
  useOffersStore,
  usePagesStore,
  useRoomsStore,
  useSocialMediaStore,
  useTermsStore,
} from 'pinia-store'
import { useRoute } from 'vue-router'
import { initMenu } from '@ui/composables'
import { useI18n, useLocalePath } from '#imports'

// Exports
export function useDataFooter() {
  const { locale: language } = useI18n()
  const localePath = useLocalePath()
  const route = useRoute()
  const isMounted = ref<Boolean>(false)

  const useSocialMedia = useSocialMediaStore()
  const useHotel = useHotelStore()
  const useTerms = useTermsStore()
  const useFacilities = useFacilitiesStore()
  const useOffers = useOffersStore()
  const useNews = useNewsStore()
  const useMeetings = useMeetingsStore()
  const useRooms = useRoomsStore()
  const useDinings = useDiningsStore()
  const useAwards = useAwardsStore()
  const useLabels = useLabelsStore()

  const profile = useHotel.getProfile
  const usePages = usePagesStore()
  const date = new Date()
  const labels = computed(() => useLabels.getLabels)
  const meetings = computed(() => useMeetings.getList)
  const awards = computed(() => useAwards.getList)
  const rooms = computed(() => useRooms.getList)
  const facilities = computed(() => useFacilities.getList)
  const socmed = computed(() => useSocialMedia.getList)
  const offers = computed(() => useOffers.data?.offers)
  const press = computed(() => useNews.data.press)
  const dinings = computed(() => useDinings.getList)
  const menu = computed(() => initMenu(usePages.getMenuFooter, 'is_footer'))
  const dataHiddenNews = computed(() => useNews.dataHidden)

  function checkMenu(slug) {
    let bool = true
    if (slug === 'whats-new' && (!press.value || press.value.length === 0))
      bool = false
    else if (slug === 'offers' && (!offers.value || offers.value.length === 0))
      bool = false
    else if (slug === 'facilities' && (!facilities.value || facilities.value.length === 0))
      bool = false
    else if (slug === 'meetings' && (!meetings.value || meetings.value.length === 0))
      bool = false
    else if (slug === 'rooms' && (!rooms.value || rooms.value.length === 0))
      bool = false
    else if (slug === 'dinings' && (!dinings.value || dinings.value.length === 0))
      bool = false
    return bool
  }
  const menuBottom = computed(() => useTerms.getList)
  const menuGeneral = computed(() => useTerms.getGeneralTerms)
  const menuTerms = computed(() => useTerms.getListTerms.filter((el: any) => el?.slug !== 'general-terms'))
  const menuGeneralTerms = computed(() => useTerms.getListTerms.filter((el: any) => el?.slug === 'general-terms'))
  const isAtNotFoundPage = computed(() => route.name === 'not-found')
  function createMenuLink(obj) {
    let req = obj
    if (isAtNotFoundPage) {
      req = {
        ...req,
        params: {
          ...req?.params,
          language: route.params?.language || language.value,
        },
      }
    }
    else {
      req = localePath({ ...req })
    }
    return req
  }
  onMounted(() => {
    isMounted.value = true
  })
  onBeforeUnmount(() => {
    isMounted.value = false
  })
  return {
    isMounted,
    menuBottom,
    menuGeneral,
    menuTerms,
    checkMenu,
    createMenuLink,
    localePath,
    dataHiddenNews,
    menuGeneralTerms,
    profile,
    date,
    labels,
    awards,
    socmed,
    menu,
  }
}
